import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "orderBy",
  standalone: false,
})
export class OrderByPipe implements PipeTransform {
  transform(value: Array<any>, field: string): Array<any> {
    return value.sort(function (left: any, right: any): number {
      let result = 0;

      if (left[field] > right[field]) {
        result = 1;
      } else if (left[field] < right[field]) {
        result = -1;
      }
      return result;
    });
  }

  private sort(left: any, right: any, field: string): number {
    if (!left[field] || !right[field]) {
      return 0;
    } else {
      if (left[field] > right[field]) {
        return 1;
      } else if (left[field] < right[field]) {
        return -1;
      }
      return 0;
    }
  }
}
